import React, {useState} from 'react'

import {
  Edit as EditIcon,
  Home as HomeIcon,
} from '@material-ui/icons'

import {MarketDialog} from 'src/modules/supply_chain/components/MarketDialog'
import {ValueField} from 'src/components/Table'
import {DetailComponent} from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const MarketDetailTable = (props: DetailTableProps) => {
  const {obj, refresh} = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <MarketDialog
          open={updateOpen}
          market={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {Icon: EditIcon, actions: [{title: 'Edit Market', onClick: () => setUpdateOpen(true)}]},
        ]}
        fields={[
          {id: 'guid', label: 'SquID', renderer: ValueField},
          {id: 'name', label: 'Name', renderer: ValueField},
        ]}
      />
    </>
  )
}
